import apiAxiosClient from './apiAxiosClient';

const tripApi = {
    getAll() {
        const url = '/api/trip/all';
        return apiAxiosClient.get(url);
    },
    insert(params) {
        const url = '/api/trip/insert';
        return apiAxiosClient.post(url, params);
    },
    update(params) {
        const url = '/api/trip/update';
        return apiAxiosClient.post(url, params);
    },
    delete(params) {
        const url = '/api/trip/delete';
        return apiAxiosClient.post(url, params);
    },
};

export default tripApi;
